// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__7Sh5F","motion":"Slider_motion__ITpI_"};